export default "__VITE_PUBLIC_ASSET__17821250__"